"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.page.login_page': '登录',
    'app.page.registration_page': '注册',
};
